import { useEffect, useState } from 'react';
import { getSubscriptionGroups } from '../api';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withFetchedSubscriptionGroups(Component) {
  return props => {
    const {
      passGroups = false,
      showInactive = false
    } = props;
    const [groupsData, setGroupsData] = useState({
      groups: [],
      userAccessibleGroups: []
    });
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
      if (!passGroups) {
        getSubscriptionGroups(showInactive).then(({
          preferencesGroups,
          userAccessibleGroups
        }) => {
          setGroupsData({
            groups: preferencesGroups,
            userAccessibleGroups
          });
          setIsLoading(false);
        }).catch(() => {
          throw new Error('Failed to get subscription groups');
        });
      }
    }, [passGroups, showInactive]);
    const {
      userAccessibleGroups,
      groups
    } = groupsData;
    if (passGroups) {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
    }
    return /*#__PURE__*/_jsx(Component, Object.assign({
      groups: groups,
      userAccessibleGroups: userAccessibleGroups,
      isLoading: isLoading
    }, props));
  };
}